import LOGO from "assets/images/brand-logo.png";
export const APP_ID = `Anori`;
export const APP_NAME = `Anori`;
export const GOOGLE_TRACKING_ID = "";
export const GOOGLE_TAG_MANAGER_ID = "";
export const SITE_HOST = "https://www.anori.africa";
export const CONTENT_API_URL = `https://www.anori.africa`;
export const API_BASE_URL = `/data`;
export const APP_LOGO = LOGO;
